import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GasConfigurationType } from 'src/app/operational-data-common/translations';

@Pipe({
  name: 'gasConfigurationType',
})
export class GasConfigurationTypePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(input: string): unknown {
    switch (input) {
      case GasConfigurationType.EGas:
        return this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.GAS_RELATED_DATA.GAS_TYPE.E_GAS'
        );
      case GasConfigurationType.LLGas:
        return this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.GAS_RELATED_DATA.GAS_TYPE.LL_GAS'
        );
      case GasConfigurationType.LiquidGas:
        return this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.GAS_RELATED_DATA.GAS_TYPE.LIQUID_GAS'
        );
    }
  }
}
